import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { TextBox, formatDate } from "../../Components/InputElements";
import { Loader, NoRecords } from "../../Components/Shimmer";
import { decodeData } from "../../Constants/constants";

class RejectedLeave extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      leave_type_id: "",
      reportrows: [],
      log_rows: [],
      leave_type_rows: [],
      decodedData: [],
      

    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetLeaveTypeList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
            if (prevState.permissions !== this.context.permissions) {
              // console.log("Permissions Updated:", this.context.permissions);
                const { permissions } = this.context;
                if (permissions.length > 0) {
                  const queryParams = new URLSearchParams(window.location.search);
                  const encodedData = queryParams.get("abs");
                  const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                  if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                    this.setState({ decodedData });
                  }
                } else {
                  console.warn("Permissions not yet available. Retrying...");
                }
            }
      }
  GetLeaveTypeList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLeaveTypeList`, { headers })
      .then((response) => {
        var data = response.data;

        if (response.data.success === true) {
          this.setState((prevState) => ({
            leave_type_rows: data.data.map((row) => ({
              value: row.leave_type_id,
              label: row.leave_type_name
            }))
          }));
        }
      });
  }
  handleSelect = (selectedOption) => {
    this.setState({ leave_type_id: selectedOption.value });
  };

  GetLeaveReports = (employee_leave_id, employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    this.setState({ log_rows: [], });
    axios
      .get(`${apiURL}Masters/GetEmployeeLeaveReport`, {
        params: {
          employee_leave_id: employee_leave_id,
          employee_id: employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (data.success === true && this.state.log_rows.length === 0) {
          this.setState({
            reportrows: data.data[0],
            log_rows: data.Logs,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };


  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Masters/GetRejectedLeaves`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          leave_type_id: this.state.leave_type_id,
        },
        headers,
      })
      .then((response) => {
        console.log("response123", response);
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };



  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSelectChange = (selectedOption) => {
    this.setState({ selectOption: selectedOption });
  };
  handleClearAll = () => {
    this.setState({
      leave_type_id: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
    }
      , () => {
        this.GetList();
      });
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
    var reportrows = this.state.reportrows;

    return (this.state.loadingList = true ?
      (<div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Rejected Leave`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Enter keyword</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                      </div>
                      <div className='col-md-3'>
                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                      </div>
                      <div className='col-md-3'>
                        <div>
                          <label>Check Leave Type</label>
                        </div>
                        <Select onChange={this.handleSelect}
                          hint={`Select Leave Type`}
                          options={this.state.leave_type_rows}
                          value={this.state.leave_type_id ? this.state.leave_type_rows.find((option) => option.value === this.state.leave_type_id) : null} // Add this line
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-end mb-3">
                      <div className='me-3'>
                        <div>
                          <label>Apply Filter</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleInputSearch}
                          // disabled={this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === ''}
                          className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && !this.state.leave_type_id) ? 'disabled' : ''}`}>
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      </div>
                      <div className=''>
                        <div>
                          <label>Show All</label>
                        </div>
                        <button
                          type="button"
                          className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && !this.state.leave_type_id) ? 'disabled' : ''}`}
                          onClick={this.handleClearAll}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Show All</button>
                      </div>
                    </div>
                    <div className="row">
                      <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} >
                        <table className={`table table-bordered table-hover`}>
                          <thead className="table-light">
                            <tr>

                              <th>Employee Code</th>
                              <th>Employee Name</th>
                              <th>Leave Type</th>
                              <th>From Date</th>
                              <th>To Date</th>
                              <th>Total Leaves Days</th>
                              <th>Leaves Status </th>
                              <th>Leaves Details </th>

                              {/* <th className="text-center">Action</th> */}
                            </tr>
                          </thead>
                          {this.state.rows.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={11}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) :
                            <tbody>
                              {this.state.rows.map((row) => {
                                return (
                                  <tr key={row.employee_leave_id}>
                                    <td>{row.employee_code}</td>
                                    <td>{row.employee_name}</td>
                                    <td>{row.heads_labels[0].concatenated_data}</td>
                                    <td>{formatDate(row.employee_leave_from_date)}</td>
                                    <td>{formatDate(row.employee_leave_to_date)}</td>
                                    <td>{row.employee_leave_days} <span>Days</span></td>
                                    <td><span className={`badge bg-${row.employee_leave_status_class}`} >{row.employee_leave_status_label}</span></td>
                                    <td className="">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-primary btn-label waves-effect waves-light"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModalPopovers"
                                        onClick={() => this.GetLeaveReports(row.employee_leave_id, row.employee_id)}
                                      >
                                        <i className="bx bx-message-alt-detail label-icon align-middle fs-16 me-2" />
                                        Leave Details
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>}
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100 p-2 table-light">
                        <button
                          disabled={
                            this.state.prev === false &&
                              this.state.loadingList === false
                              ? true
                              : false
                          }
                          type="button"
                          onClick={() => this.handlePrev()}
                          className={`btn btn-warning btn-label waves-effect waves-light`}
                        >
                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                          Previous
                        </button>
                        <div
                          className="col-md-4"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {
                            <small>
                              Total Records: {this.state.total_records} |
                              Total Pages: {this.state.total_pages} |
                              Current Page: {this.state.page}
                            </small>
                          }
                        </div>
                        <div className="col-md-2">
                          <select
                            className="form-select"
                            onChange={(e) => this.handleChange(e)}
                          >
                            {Array.from(
                              { length: this.state.total_pages },
                              (_, i) => (
                                <option
                                  selected={this.state.page === i + 1}
                                  key={i}
                                  value={i + 1}
                                >
                                  Page {i + 1}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <select
                            className="form-select"
                            onChange={this.handleLimitChange}
                            value={this.state.limit}
                          >
                            {limitOptions.map((option) => (
                              <option key={option} value={option}>
                                Limit {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          disabled={
                            this.state.next === false &&
                              this.state.loadingList === false
                              ? true
                              : false
                          }
                          type="button"
                          onClick={() => this.handleNext()}
                          className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="modal fade" id="exampleModalPopovers" tabIndex={-1} aria-labelledby="exampleModalPopoversLabel" aria-modal="true">
                      <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                          </div>
                          <div className="modal-body">
                            <div class="card shadow-none">
                              <div class="card-header d-flex justify-content-between align-items-center">
                                <h6 class="card-title mb-0">{reportrows.employee_name}</h6>
                                <h6 class="card-title mb-0">
                                  {reportrows.leave_type_name && reportrows.leave_type_name.length > 0 ? reportrows.leave_type_name[0].leave_type_name : 'No Leave Type'}
                                </h6>
                                <a href={`${reportrows.employee_leave_document_url}`}
                                  className={`${!reportrows.employee_leave_document_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                  style={{ marginTop: "10px", float: 'right' }}
                                  target="_blank" rel="noopener noreferrer">
                                  {/* <i className="ri-eye-fill label-icon align-middle fs-16 me-2" /> */}
                                  View Uploaded Document
                                </a>
                              </div>
                              <div class="card-body">
                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                  <h6 >From :{formatDate(reportrows.employee_leave_from_date)}
                                    <div><span className="text-muted mt-2">{reportrows.employee_leave_from_day_unit}</span></div>
                                  </h6>
                                  <h6 >To :{formatDate(reportrows.employee_leave_to_date)}
                                    <div><span className="text-muted mt-2">{reportrows.employee_leave_to_day_unit}</span></div>
                                  </h6>
                                  <h6 >Total Leave days :{reportrows.employee_leave_days}</h6>
                                </div>
                              </div>
                              <div class="card-footer d-flex justify-content-between align-items-center flex-wrap">
                                <div className="">
                                  <span >Leave Reason</span>
                                  <p class="card-text text-muted mb-0">{reportrows.employee_leave_reason || "No Reason"}</p>
                                </div>
                                <span className={`badge bg-${reportrows.employee_leave_status_class}`}>{reportrows.employee_leave_status_label}</span>
                              </div>
                            </div>

                            <div className="my-3">
                              <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>

                            </div>

                            <table className="table table-nowrap text-center mb-0">

                              <thead className="table-light">
                                <tr>
                                  <th>Action Date</th>
                                  <th>Action By</th>
                                  <th>Leave Type</th>
                                  <th>From Date</th>
                                  <th>To Date</th>
                                  <th>Total Leave Days</th>
                                  <th>Reason</th>
                                  <th>Remark</th>
                                  <th>Status</th>

                                </tr>
                              </thead>
                              <tbody>
                                {this.state.log_rows.map((row) => {
                                  var leave_obj = JSON.parse(row.leave_apply_object);
                                  return (
                                    <tr key={row.employee_leave_log_id}>
                                      <td>{formatDate(row.created_date)}</td>
                                      <td>{row.company_user_name[0].user_name}</td>
                                      <td>{leave_obj.leave_type_name}</td>
                                      <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                      <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                      <td>{leave_obj.employee_leave_days}</td>
                                      <td>{leave_obj.employee_leave_reason}</td>
                                      <td>{row.remark}</td>
                                      <td ><span className={`badge bg-${row.employee_leave_log_status_class}`}>{row.employee_leave_status_label}</span></td>
                                    </tr>
                                  )
                                })}

                              </tbody>
                            </table>

                          </div>
                          <div className="modal-footer">
                            <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>) : <div>
        <Loader />
      </div>
    );
  }
}
export default withRouter(RejectedLeave);
